import { useDispatch, useSelector } from 'react-redux';
import { RootReducerState } from '../../store/reducer';
import Button from '../Common/Button';
import InputText from '../Common/InputText';
import { useFormik } from 'formik';
import { useCallback, useEffect, useReducer } from 'react';
import CautionModal from '../Modals/Confirmation/Caution';
import { reducer, TodoActionTypes } from './reducer';
import {
  createTodo,
  deleteTodo,
  getTodos,
  updateTodo,
} from '../../store/Todos/actions';
import moment from 'moment';
import Todoitem from './TodoItem';

interface TodoProps {
  onTodoOpen: () => void;
  date: Date;
}

const Todo = ({ onTodoOpen, date }: TodoProps) => {
  // Initialise component hooks
  const dispatch = useDispatch();
  const [
    { showTodoDropdown, showDeleteConfirmationModal, selectedId },
    action,
  ] = useReducer(reducer, {
    showTodoDropdown: false,
    showDeleteConfirmationModal: false,
    selectedId: null,
  });
  const formik = useFormik({
    initialValues: {
      content: '',
    },
    onSubmit: (values) => {
      dispatch(
        createTodo(branch_id, moment(date).format('YYYY-MM-DD'), values.content)
      );
      formik.resetForm();
    },
  });

  // Load state from redux
  const branch_id = useSelector(
    (state: RootReducerState) => state.dashboard.selectedBranch.id
  );
  const todoList = useSelector((state: RootReducerState) => state.todos.todos);

  // Additional helper methods
  const handleShowTodo = useCallback(() => {
    action({ type: TodoActionTypes.SHOW_TODO_DROPDOWN });
    onTodoOpen();
  }, [action, onTodoOpen]);

  // On component did mount
  useEffect(() => {
    dispatch(getTodos(branch_id, moment(date).format('YYYY-MM-DD')));
  }, [date]);

  return (
    <>
      <div className="absolute left-[-13px] bottom-[10px] z-0 h-[25px] w-[25px] rounded-full bg-red-400 p-1">
        <p className="text-center text-xs font-bold text-white">
          {todoList.length}
        </p>
      </div>
      <div className="z-20 cursor-pointer" onClick={handleShowTodo}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          className="h-6 w-6"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01"
          ></path>
        </svg>
      </div>

      {showTodoDropdown && (
        <div className="absolute right-0 top-[42px] z-50">
          <div
            className="w-full space-y-4 rounded border-2 border-gray-200 bg-white p-4"
            style={{ width: '350px' }}
          >
            <div className="">
              <h3 className="text-base font-bold">Today</h3>
            </div>

            <div className="flex h-40 flex-col gap-2 overflow-y-auto rounded-md border border-gray-300 p-2">
              {todoList &&
                todoList.map((item) => (
                  <Todoitem
                    key={item.id}
                    item={item}
                    onChecked={() => {
                      dispatch(
                        updateTodo(
                          branch_id,
                          item.id,
                          item.content,
                          !item.completed_at
                        )
                      );
                    }}
                    onDelete={() =>
                      action({
                        type: TodoActionTypes.SHOW_DELETE_CONFIRMATION_MODAL,
                        payload: item.id,
                      })
                    }
                  />
                ))}
            </div>

            <form onSubmit={formik.handleSubmit} className="mt-2 space-y-2">
              <InputText
                type={'text'}
                id="content"
                name="content"
                onChange={formik.handleChange}
                value={formik.values.content}
                placeholder="New todo"
                required
              />

              <div className="flex flex-row items-center justify-between">
                <Button type="submit" className="flex">
                  <span>+</span>
                  <p>Add todo</p>
                </Button>
                <Button
                  type="button"
                  onClick={() =>
                    action({
                      type: TodoActionTypes.HIDE_TODO_DROPDOWN,
                    })
                  }
                >
                  Cancel
                </Button>
              </div>
            </form>
          </div>
        </div>
      )}

      <CautionModal
        title={'Delete Todo'}
        body={
          'Are you sure you want to remove this todo? This action is permanant and cannot be recovered.'
        }
        actionText={'Delete'}
        action={() => {
          dispatch(deleteTodo(branch_id, selectedId));
          action({
            type: TodoActionTypes.HIDE_DELETE_CONFIRMATION_MODAL,
          });
        }}
        open={showDeleteConfirmationModal}
        setOpen={() =>
          action({
            type: TodoActionTypes.HIDE_DELETE_CONFIRMATION_MODAL,
          })
        }
      />
    </>
  );
};

export default Todo;
